import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "container"
  ]

  static values = {
    key: String,
    language: String
  }

  async connect() {
    try {
      await this.loadScript('https://smartcaptcha.yandexcloud.net/captcha.js')

      if (window.smartCaptcha) {
        window.smartCaptcha.render(this.containerTarget, {
          sitekey: this.keyValue,
          hl: this.languageValue
        })
      }
    } catch (error) {
      console.error(error)
    }
  }

  loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => resolve(script);
      script.onerror = () => reject(new Error(`Script load error for ${url}`));
      document.head.append(script);
    })
  }
}
